import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getGecko} from '../../../apis/gecko/getChart'

const useGecko = (days: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.analysis.getGecko(),
        queryFn: async () => {
            const {data} = await getGecko(days)
            return data
        },
    })

    return {data, refetch}
}

export default useGecko
